import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-td4",
  "use": "icon-td4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-td4\"><path d=\"M102.4 896V633.6H25.6V896c0 57.6 44.8 102.4 102.4 102.4h256v-76.8H128c-12.8 0-25.6-12.8-25.6-25.6zM896 25.6H633.6v76.8H896c12.8 0 25.6 12.8 25.6 25.6v230.4h76.8V128c0-57.6-44.8-102.4-102.4-102.4zM921.6 896c0 12.8-12.8 25.6-25.6 25.6H633.6v76.8H896c57.6 0 102.4-44.8 102.4-102.4V633.6h-76.8V896zM102.4 128c0-12.8 12.8-25.6 25.6-25.6h256V25.6H128C70.4 25.6 25.6 70.4 25.6 128v230.4h76.8V128z m288 172.8L224 729.6h70.4l38.4-108.8h185.6l38.4 108.8h70.4L460.8 300.8h-70.4zM352 563.2l70.4-192 70.4 192H352z m320-262.4h64v428.8h-64z\" p-id=\"11109\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/td4.svg
// module id = kTLa
// module chunks = 197